import React from 'react';
import { addCommas } from '@persian-tools/persian-tools';
import styles from './PriceRangeMobile.module.scss';
import Icon from '@/components/UI/icon/Icon';
import Box from '@/components/UI/box/Box';
import Button from '@/components/UI/button/Button';
import TextField from '@/components/UI/textField/TextField';
import Slider from '@/components/UI/slider/Slider';
import Typography from '@/components/UI/typography/Typography';
import { useRouter } from 'next/router';
type IPriceRangeMobile = {
  value: number[];
  onClose: () => void;
  setValue: (arg: number[]) => void;
  step: number;
  min: number;
  max: number;
  submitData: () => void;
  resetFilter: (e: any) => void;
  hasPriceRangeFilter: boolean;
};
const PriceRangeMobile = ({
  value,
  onClose,
  setValue,
  step,
  min,
  max,
  submitData,
  resetFilter
}: IPriceRangeMobile) => {
  const router = useRouter();
  const preventTextHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/[^0-9۰-۹]/g, '');
    if (+value > max) {
      value = String(max);
    } else if (+value < min) {
      value = String(min);
    }
    value = value.slice(0, 8);
    return value;
  };
  return <Box className={styles['price-range-mobile-container']} data-sentry-element="Box" data-sentry-component="PriceRangeMobile" data-sentry-source-file="PriceRangeMobile.tsx">
      <Box className={styles['price-range-header']} data-sentry-element="Box" data-sentry-source-file="PriceRangeMobile.tsx">
        <Box onClick={onClose} className={styles['close-icon-section']} data-sentry-element="Box" data-sentry-source-file="PriceRangeMobile.tsx">
          <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="PriceRangeMobile.tsx" />
        </Box>
        <Typography variant="title_Bold" data-sentry-element="Typography" data-sentry-source-file="PriceRangeMobile.tsx">
          {router.query?.mid_term ? router.query?.checkin && router.query?.checkout ? 'قیمت کل' : 'قیمت ماهانه' : 'قیمت برای هر شب'}
        </Typography>
      </Box>
      <Box className={styles['price-range-section']} data-sentry-element="Box" data-sentry-source-file="PriceRangeMobile.tsx">
        <Box className={styles['price-range-input-section']} data-sentry-element="Box" data-sentry-source-file="PriceRangeMobile.tsx">
          <Box className={styles['price-range-input']} data-sentry-element="Box" data-sentry-source-file="PriceRangeMobile.tsx">
            <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="PriceRangeMobile.tsx">از</Typography>
            <TextField type="tel" label="حداقل قیمت" onChange={e => {
            setValue([+preventTextHandler(e), value[1]]);
          }} onClear={() => {
            setValue([min, value[1]]);
          }} value={addCommas(value[0])} endAdornment="تومان" readOnly data-sentry-element="TextField" data-sentry-source-file="PriceRangeMobile.tsx" />
          </Box>
          <Box className={styles['price-range-input']} data-sentry-element="Box" data-sentry-source-file="PriceRangeMobile.tsx">
            <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="PriceRangeMobile.tsx">تا</Typography>
            <TextField type="tel" label="حداکثر قیمت" onChange={e => {
            setValue([value[0], +preventTextHandler(e)]);
          }} onClear={() => {
            setValue([value[0], max]);
          }} value={addCommas(value[1])} endAdornment="تومان" readOnly data-sentry-element="TextField" data-sentry-source-file="PriceRangeMobile.tsx" />
          </Box>
        </Box>
        <Box className={styles['price-range-slider']} data-sentry-element="Box" data-sentry-source-file="PriceRangeMobile.tsx">
          <Slider value={value} onChange={newValue => {
          setValue(newValue as number[]);
        }} min={min} max={max} step={step} data-sentry-element="Slider" data-sentry-source-file="PriceRangeMobile.tsx" />
          <Box className={styles['min-max-price-text']} data-sentry-element="Box" data-sentry-source-file="PriceRangeMobile.tsx">
            <Typography variant="bodyL" data-sentry-element="Typography" data-sentry-source-file="PriceRangeMobile.tsx">گران‌ترین</Typography>
            <Typography variant="bodyL" data-sentry-element="Typography" data-sentry-source-file="PriceRangeMobile.tsx">ارزان‌ترین</Typography>
          </Box>
        </Box>
      </Box>
      <Box className={styles['price-range-button']} data-sentry-element="Box" data-sentry-source-file="PriceRangeMobile.tsx">
        <Button format="text" onClick={resetFilter} data-sentry-element="Button" data-sentry-source-file="PriceRangeMobile.tsx">
          پاک کردن
        </Button>
        <Button format="primary" onClick={submitData} disabled={value[0] > value[1]} data-sentry-element="Button" data-sentry-source-file="PriceRangeMobile.tsx">
          اعمال بازه قیمتی
        </Button>
      </Box>
    </Box>;
};
export default PriceRangeMobile;